import { filterAlerts } from '@odd/domain';
import { useSetSensitive } from '../lib/queries';
import { fmtShort } from '../lib/format';
import { useBoardCtx } from './BoardContext';
import { useErpLinks } from '../lib/erp';
import { ErpLink, Panel, SegmentBadge, Toggle } from './ui';

/** Juntas en las próximas 4 semanas; el AFF marca las sensibles. */
export function Meetings() {
  const { board, filter, officeId } = useBoardCtx();
  const set = useSetSensitive(officeId);
  const erp = useErpLinks();
  const list = filterAlerts(board.upcomingMeetings, filter);
  return (
    <Panel
      className="meetings-panel"
      title="Juntas próximas"
      description={`${list.length} en 4 semanas · ${list.filter((m) => m.sensitive).length} sensibles`}
    >
      {list.length === 0 ? (
        <p className="text-sm text-ink-3">No hay juntas convocadas en las próximas 4 semanas.</p>
      ) : (
        <ul className="grid grid-cols-[minmax(0,1fr)] gap-1">
          {list.map((m) => (
            <li
              key={m.meetingId}
              className="meeting-row flex min-w-0 items-center gap-3 rounded-xl px-2 py-2"
            >
              <div className="meeting-days grid w-12 shrink-0 place-items-center rounded-lg bg-card-2 py-1">
                <span className="tabular text-lg leading-none font-extrabold text-ink">{m.days}</span>
                <span className="text-[10px] text-ink-3 uppercase">días</span>
              </div>
              <div className="meeting-summary min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <SegmentBadge segment={m.segment} />
                  <ErpLink
                    href={erp.meeting(m.communityId, m.meetingId)}
                    title={`${m.communityName} · abrir la junta en Eleva`}
                    className="min-w-0 text-sm font-bold"
                  >
                    <span className="truncate">{m.communityName}</span>
                  </ErpLink>
                </div>
                <div className="text-xs text-ink-3">
                  {fmtShort(m.date)} · {m.type}
                </div>
              </div>
              <div className="meeting-sensitive shrink-0">
                <Toggle
                  isSelected={m.sensitive}
                  isDisabled={set.isPending}
                  onChange={(sensitive) => set.mutate({ meetingId: m.meetingId, sensitive })}
                  label="Sensible"
                  ariaLabel={`Junta de ${m.communityName} sensible`}
                />
              </div>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
}
